import { registerClienteEntranceResolver } from '@modules/navegacao-v2/utils/module-entrance'
import { registrarTourDoModulo } from '@modules/central-config/utils/tour-registry'
import * as complianceStore from './store'
import { resolveComplianceClienteEntrance } from './utils/cliente-entrance'
import { montarTourDoCompliance } from './utils/iniciar-tour-guiado'
import { MODULE_KEY_COMPLIANCE } from './constants/tour-compliance'

export function complianceModule({ store }) {
  store.registerModule('compliance', {
    ...complianceStore,
    namespaced: true,
  })

  // Navegação client-centric (navegacao-v2): registra como o Compliance decide
  // rota + payload do modal "Visão geral cliente" ao ser acessado com um
  // cliente ativo.
  registerClienteEntranceResolver('compliance', resolveComplianceClienteEntrance)

  // Tour guiado da Jornada: o MÓDULO se registra, o central-config só consulta
  // — é o que permite `startTaskNavigation` guiar sem importar o compliance.
  // Registrar aqui (e não na view) cobre toda superfície de "Iniciar etapa":
  // o accordion da Jornada, a barra embutida na Visão Geral e o card da Home.
  registrarTourDoModulo(MODULE_KEY_COMPLIANCE, montarTourDoCompliance)
}
